.modal {
  background-color: var(--colors-background);
  border-radius: 3px;
  color: #1a1a1a;
  max-width: 90%;
  margin: 3vh auto;
  position: relative;

  &:focus {
    outline-width: 0;
  }

  @media (--reefer-media-tablet-min) {
    margin: 10vh auto;
    width: 480px;
  }
}

.modal--full-width {
  width: 100%;

  @media (--reefer-media-desktop-sm-min) {
    width: 70%;
  }
}

.modal--medium {
  width: 600px;
}

.modal--narrow {
  width: 360px;
}

.modal--small {
  width: 360px;
  text-align: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background-color: rgb(0 0 0 / 60%);
  z-index: var(--layers-modal);
  overflow-y: scroll;
}

/* applied via JS when opening a modal with fixedBody = true; prevents cursor rendering errors in iOS11 */
.body--fixed {
  position: fixed;
}
